var _Path, _Path2, _Path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgVipStatusCrown = function SvgVipStatusCrown(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 16"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#FFC",
    d: "m1.969 5 4.594 3L10.5 2l3.938 6 4.593-3-2.625 7.5H4.594z"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    fill: "#000",
    d: "M4.594 14h11.812z"
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    stroke: "#FFC",
    d: "M4.594 14h11.812"
  })));
};
export default SvgVipStatusCrown;